import { render, staticRenderFns } from "./AdministratorDetail.vue?vue&type=template&id=6f92537b&"
import script from "./AdministratorDetail.vue?vue&type=script&lang=js&"
export * from "./AdministratorDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports